import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Applies an admin-defined CSS class to <body> when the current route exactly
 * matches a menu item's URL (incl. the locked Home item for "/"). This lets the
 * admin target non-CMS pages (e.g. /photos, /photos/popular) from the Main
 * Custom CSS using `.their-class ...` selectors.
 */
const RouteBodyClass = () => {
  const [routeClasses, setRouteClasses] = useState({});
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE}/menu-items`)
      .then(({ data }) => { if (!cancelled) setRouteClasses(data.route_classes || {}); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const cls = (routeClasses[location.pathname] || '').trim();
    if (!cls) return undefined;
    const tokens = cls.split(/\s+/).filter(Boolean);
    document.body.classList.add(...tokens);
    return () => document.body.classList.remove(...tokens);
  }, [routeClasses, location.pathname]);

  return null;
};

export default RouteBodyClass;
